import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { WebStorybyIDFetchData } from "../../redux/actions/WebstoryByIdAction";
import { Helmet } from "react-helmet";
import { webStoryAnalytics } from "../../redux/actions/commonAction";
import ReactGA from "react-ga4";
import { IncrementWebStoryViewsFetchData } from "../../redux/actions/incrementWebViewStroy";
import { generateResizedImageUrl } from "../../utils/httpService";

// code added ny mansi vaghela.
const WebStoryPage = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const [isAmpReady, setIsAmpReady] = useState(false);

  const storyData = useSelector((state) => state?.webStoryById?.data);
  const loading = useSelector((state) => state?.webStoryById?.loading);
  const error = useSelector((state) => state?.webStoryById?.error);
  const { 21: assetbaseUrl } = useSelector(
    (state) => state?.SettingReducer?.data
  );

  // Use watchmoreStories from API if available
  const nextStories = useSelector((state) => state?.webStoryById?.data);

  // Define arrays of animations to cycle through
  const imageAnimations = [
    {
      animateIn: "fly-in-left",
      duration: "1.5s",
    },
    // {
    //   animateIn: "zoom-out",
    //   duration: "2.5s",
    //   scale: "1.1",
    // },
    {
      animateIn: "rotate-in-left",
      duration: "1s"
    },
    {
      animateIn: "rotate-in-right",
      duration: "1s"
    },
    {
      animateIn: "fly-in-left",
      duration: "1.5s",
    },
    {
      animateIn: "zoom-out",
      duration: "2.5s",
      scale: "1.1",
    },
    {
      animateIn: "fly-in-right",
      duration: "1.5s",
    },
    {
      animateIn: "zoom-out",
      duration: "2.5s",
      scale: "1.1",
    },
  ];

  const titleAnimations = [
    {
      animateIn: "fade-in",
      duration: "1s",
    },
    {
      animateIn: "slide-in-top",
      duration: "1s",
    },

    {
      animateIn: "fly-in-bottom",
      duration: "1s",
    },
    {
      animateIn: "whoosh-in-right",
      duration: "1.2s",
    },
    {
      animateIn: "whoosh-in-left",
      duration: "1.2s",
    },
  ];

  const descriptionAnimations = [
    {
      animateIn: "fade-in",
      duration: "1s",
      delay: "0.3s",
    },
    {
      animateIn: "fly-in-bottom",
      duration: "1s",
      delay: "0.5s",
    },
    {
      animateIn: "twirl-in",
      duration: "1.2s",
      delay: "0.4s",
    },
    {
      animateIn: "fade-in",
      duration: "1s",
      delay: "0.3s",
    },
    { animateIn: "scale-fade-up", duration: "1.2s", delay: "0.5s" },
    { animateIn: "rotate-in-right", duration: "1s", delay: "0.6s" },
    { animateIn: "rotate-in-left", duration: "1s", delay: "0.6s" },
    { animateIn: "fly-in-right", duration: "1s", delay: "0.4s" },
    {
      animateIn: "fly-in-bottom",
      duration: "1s",
      delay: "0.5s",
    },
  ];

  const watchMoreImageAnimations = [
    {
      animateIn: "fly-in-right",
      duration: "1.1s",
      delay: "0.4s",
    },
    {
      animateIn: "fly-in-left",
      duration: "1.1s",
      delay: "0.4s",
    },
    {
      animateIn: "fly-in-right",
      duration: "1.1s",
    },
    {
      animateIn: "fly-in-left",
      duration: "1.1s",
    },
    {
      animateIn: "whoosh-in-left",
      duration: "1.3s",
    },
    {
      animateIn: "whoosh-in-right",
      duration: "1.3s",
    },
  ];

  const watchMoreTitleAnimations = [
    {
      animateIn: "fly-in-left",
      duration: "1.1s",
      delay: "0.4s",
    },
    {
      animateIn: "fly-in-right",
      duration: "1.1s",
      delay: "0.4s",
    },
    {
      animateIn: "fly-in-left",
      duration: "1.1s",
      delay: "0.4s",
    },
    {
      animateIn: "fly-in-right",
      duration: "1.1s",
      delay: "0.4s",
    },
    {
      animateIn: "whoosh-in-left",
      duration: "1.2s",
      delay: "0.2s",
    },
    {
      animateIn: "whoosh-in-right",
      duration: "1.2s",
      delay: "0.2s",
    },
  ];

  const watchMoreCardAnimations = [
    {
      animateIn: "fly-in-right",
      duration: "1.1s",
    },
    {
      animateIn: "fly-in-left",
      duration: "1.1s",
    },
    {
      animateIn: "fly-in-right",
      duration: "1.1s",
    },
    {
      animateIn: "fly-in-left",
      duration: "1.1s",
    },
    {
      animateIn: "whoosh-in-left",
      duration: "1.3s",
    },
    {
      animateIn: "whoosh-in-right",
      duration: "1.3s",
    },
  ];

  useEffect(() => {
    const urlParts = Object.values(params)
      .filter((part) => part !== undefined && part !== "")
      .join("/");
    if (urlParts) {
      dispatch(WebStorybyIDFetchData(urlParts));
    }
  }, [dispatch, params]);

  useEffect(() => {
    let shareBtn = null;
    const handleClick = () => {
      // Build the payload dynamically
      const payload = {
        userid: null, // Replace with actual user id if available
        name: "wa", // Replace with actual name if needed
        storyid: storyData?.id, // Use the current story's id
        agent: navigator.userAgent,
        time: new Date().toString(),
        screen: `${window.screen.width}x${window.screen.height}`,
        screenuse: `${window.innerWidth}x${window.innerHeight}`,
      };

      // Call your API or dispatch your action
      dispatch(webStoryAnalytics(payload, storyData?.id));
    };

    // Function to search all shadow roots for the share button
    const attachListener = () => {
      const all = document.querySelectorAll("*");
      for (let el of all) {
        if (el.shadowRoot) {
          const btn = el.shadowRoot.querySelector(
            ".i-amphtml-story-share-control"
          );
          if (btn && !btn._customListenerAttached) {
            btn.addEventListener("click", handleClick);
            btn._customListenerAttached = true;
            shareBtn = btn;
            return;
          }
        }
      }
    };

    // Observe DOM changes to detect when the share button is added
    const observer = new MutationObserver(() => {
      attachListener();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Try to attach immediately in case the button is already there
    attachListener();

    // Cleanup

    return () => {
      observer.disconnect();
      if (shareBtn) {
        shareBtn.removeEventListener("click", handleClick);
      }
    };
  }, [dispatch, storyData]);

  useEffect(() => {
    // All unwanted scripts you want to remove
    const unwantedScripts = [
      "pubads_impl.js",
      "https://securepubads.g.doubleclick.net/tag/js/gpt.js",
      "adScript.js",
      "adScriptSandesh_new.js",
      "a8a7c57675bfaaef6c33489b775985b7947470f1.js",
      "beacon.js",
      "loader.js",
      "unblockia.com/hb.js",
    ];

    // Remove matching script tags
    document.querySelectorAll("script").forEach((script) => {
      if (
        unwantedScripts.some((bad) => script.src && script.src.includes(bad))
      ) {
        script.remove();
      }
    });

    // Also remove ad div containers if needed
    const adDivs = document.querySelectorAll("#gabyub_hb, .ad-class");
    adDivs.forEach((div) => div.remove());
  }, []);

  useEffect(() => {
    if (storyData) {
      // Add amp attribute to HTML tag for AMP compliance
      if (
        !document.documentElement.hasAttribute("amp") &&
        !document.documentElement.hasAttribute("⚡")
      ) {
        document.documentElement.setAttribute("amp", "");
      }

      // Set the canonical URL for sharing
      const canonicalUrl = window.location.href;
      let canonicalLink = document.querySelector('link[rel="canonical"]');
      if (!canonicalLink) {
        canonicalLink = document.createElement("link");
        canonicalLink.setAttribute("rel", "canonical");
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.setAttribute("href", canonicalUrl);

      // Load AMP scripts
      // const ampScript = document.createElement("script");
      // ampScript.async = true;
      // ampScript.src = "https://cdn.ampproject.org/v0.js";

      // const ampStoryScript = document.createElement("script");
      // ampStoryScript.async = true;
      // ampStoryScript.src = "https://cdn.ampproject.org/v0/amp-story-1.0.js";
      // ampStoryScript.setAttribute("custom-element", "amp-story");

      // // Add AMP video script
      // const ampVideoScript = document.createElement("script");
      // ampVideoScript.async = true;
      // ampVideoScript.src = "https://cdn.ampproject.org/v0/amp-video-0.1.js";
      // ampVideoScript.setAttribute("custom-element", "amp-video");

      // Prevent duplicate injection
      // if (
      //   !document.head.querySelector(
      //     'script[src="https://cdn.ampproject.org/v0.js"]'
      //   )
      // ) {
      //   document.head.appendChild(ampScript);
      // }
      // if (
      //   !document.head.querySelector(
      //     'script[src="https://cdn.ampproject.org/v0/amp-story-1.0.js"]'
      //   )
      // ) {
      //   document.head.appendChild(ampStoryScript);
      // }
      // if (
      //   !document.head.querySelector(
      //     'script[src="https://cdn.ampproject.org/v0/amp-video-0.1.js"]'
      //   )
      // ) {
      //   document.head.appendChild(ampVideoScript);
      // }

      // AMP boilerplate CSS
      if (!document.head.querySelector("style[amp-boilerplate]")) {
        const ampBoilerplate = document.createElement("style");
        ampBoilerplate.setAttribute("amp-boilerplate", "");
        ampBoilerplate.textContent = `
          body {
            -webkit-animation: -amp-start 8s steps(1, end) 0s 1 normal both;
            -moz-animation: -amp-start 8s steps(1, end) 0s 1 normal both;
            -ms-animation: -amp-start 8s steps(1, end) 0s 1 normal both;
            animation: -amp-start 8s steps(1, end) 0s 1 normal both;
          }
          @-webkit-keyframes -amp-start {
            from { visibility: hidden; } to { visibility: visible; }
          }
          @-moz-keyframes -amp-start {
            from { visibility: hidden; } to { visibility: visible; }
          }
          @-ms-keyframes -amp-start {
            from { visibility: hidden; } to { visibility: visible; }
          }
          @-o-keyframes -amp-start {
            from { visibility: hidden; } to { visibility: visible; }
          }
          @keyframes -amp-start {
            from { visibility: hidden; } to { visibility: visible; }
          }
        `;
        document.head.appendChild(ampBoilerplate);
      }
      if (!document.head.querySelector("noscript[amp-boilerplate]")) {
        const ampBoilerplateNoScript = document.createElement("noscript");
        ampBoilerplateNoScript.setAttribute("amp-boilerplate", "");
        ampBoilerplateNoScript.innerHTML = `<style amp-boilerplate>body {-webkit-animation: none;-moz-animation: none;-ms-animation: none;animation: none;}</style>`;
        document.head.appendChild(ampBoilerplateNoScript);
      }

      // Updated AMP styles with additional animation styles
      const style = document.createElement("style");
      style.setAttribute("amp-custom", "");
      style.textContent = `
        .story-content {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          padding: 32px 24px 5px; /* Pushed further down */
          background: linear-gradient(0deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0) 100%); /* Lighter gradient */
          color: white;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .story-title-web {
          font-size: 22px; /* Smaller font size */
          font-weight: bold;
          text-align: center;
          max-width: 90%;
          margin-left: auto;
          margin-right: auto;
        }
        .story-description {
          font-size: 14px;
          font-weight: bold; /* Made description bold as requested */
          line-height: 1.4;
          text-align: center;
          max-width: 85%;
          margin: 0 auto;
        }
        
          .story-credit {
          margin-top: 10px;
      text-align: center;
    font-size: 12px;
}

        amp-story-grid-layer.bottom {
          padding-bottom: 10px; /* Reduced to push content lower */
        }
        .animate-in {
          transition-timing-function: cubic-bezier(0.4, 0.0, 0.2, 1);
        }
      `;
      document.head.appendChild(style);

      setIsAmpReady(true);
    }
  }, [storyData, assetbaseUrl]);

  useEffect(() => {
    ReactGA.event({
      category: "webstory",
      action: "webstory",
      label: storyData.url,
    });
  }, []);

  // Use refs to persist tracking state across re-renders
  const setupCompletedRef = useRef(false);
  const storyViewTrackedRef = useRef(false);
  const trackedStoryUrlRef = useRef(null);
  const lastApiCallTimeRef = useRef(new Map());
  const pageViewCountsRef = useRef(new Map());
  const intersectionObserversRef = useRef([]);
  const checkIntervalRef = useRef(null);
  const lastTrackedPageIdRef = useRef(null);

  // Track story views and page views
  useEffect(() => {
    if (!storyData || !isAmpReady) return;
    // Prevent multiple setups for the same story URL
    const currentStoryUrl = storyData?.url;
    if (!currentStoryUrl) return;

    // If we've already set up tracking for this story URL, skip
    if (setupCompletedRef.current && trackedStoryUrlRef.current === currentStoryUrl) {
      return;
    }

    // Track story view when story is loaded (only once per story URL)
    const trackStoryView = () => {
      if (!storyViewTrackedRef.current && currentStoryUrl && trackedStoryUrlRef.current !== currentStoryUrl) {
        storyViewTrackedRef.current = true;
        trackedStoryUrlRef.current = currentStoryUrl;

        // Call API to increment story view
        dispatch(IncrementWebStoryViewsFetchData(currentStoryUrl))
          .then(() => {
          })
          .catch((error) => {
            // Reset on error so it can be retried
            storyViewTrackedRef.current = false;
            trackedStoryUrlRef.current = null;
          });
      }
    };

    // Unified function to track page view with deduplication
    // Track each page only once per navigation (not on every poll check)
    const trackPageView = (pageId, pageNumber) => {
      if (!currentStoryUrl || !pageId || pageId === "unknown") return;

      const now = Date.now();
      const lastCall = lastApiCallTimeRef.current.get(pageId) || 0;

      // Throttle: Only prevent if same page was tracked very recently (within 2 seconds)
      // This prevents rapid duplicate calls but allows tracking when user navigates back
      if (now - lastCall < 2000) {
        return;
      }

      // Update tracking
      lastApiCallTimeRef.current.set(pageId, now);
      const currentCount = pageViewCountsRef.current.get(pageId) || 0;
      pageViewCountsRef.current.set(pageId, currentCount + 1);

      ReactGA.send({
        hitType: "pageview",
        page: `/webstory/${currentStoryUrl}?${pageId}`,
        title: "Webstory",
      });

      window._comscore = window._comscore || [];
      window._comscore.push({
        c1: "2",
        c2: "38736750",
        page: `/webstory/${currentStoryUrl}?${pageId}`,
      });

      // Force SPA beacon
      if (window.COMSCORE && window.COMSCORE.beacon) {
        window.COMSCORE.beacon({
          c1: "2",
          c2: "38736750",
          page: `/webstory/${currentStoryUrl}?${pageId}`,
        });
      }
      // Call API to increment page view
      dispatch(IncrementWebStoryViewsFetchData(currentStoryUrl, pageId, pageNumber))
        .then(() => {
        })
        .catch((error) => {
        });
    };

    // Function to find and observe all story pages
    const setupPageTracking = () => {
      // Prevent multiple setups
      if (setupCompletedRef.current) {
        return true;
      }

      const storyElement = document.querySelector("amp-story");
      if (!storyElement) {
        return false;
      }


      // Track story view when story element is found (only once)
      trackStoryView();

      // Find all amp-story-page elements
      const findPages = () => {
        const pages = [];

        // Try direct query first (most reliable)
        const directPages = document.querySelectorAll("amp-story-page[id^='page']");
        directPages.forEach(page => {
          if (page.id && page.id.startsWith('page')) {
            pages.push(page);
          }
        });

        // If no pages found, try shadow DOM
        if (pages.length === 0) {
          const allElements = document.querySelectorAll("*");
          allElements.forEach(el => {
            if (el.shadowRoot) {
              const shadowPages = el.shadowRoot.querySelectorAll("amp-story-page[id^='page']");
              shadowPages.forEach(page => {
                if (page.id && page.id.startsWith('page')) {
                  pages.push(page);
                }
              });
            }
          });
        }

        return [...new Set(pages)]; // Remove duplicates
      };

      const pages = findPages();

      if (pages.length === 0) {
        return false;
      }

      // Set initial page reference (without tracking) - wait for AMP to initialize
      // This is just to know the starting point, we don't track on initial load
      setTimeout(() => {
        const activePage = document.querySelector(
          "amp-story-page.active[id^='page'], amp-story-page.i-amphtml-story-page-active[id^='page'], amp-story-page[active][id^='page']"
        ) || document.querySelector('[id^="page"].active, [id^="page"].i-amphtml-story-page-active');

        if (activePage) {
          const pageId = activePage.id || "unknown";
          if (pageId !== "unknown" && pageId.startsWith('page')) {
            lastTrackedPageIdRef.current = pageId;
          }
        } else {
          // Fallback: set to page1 if no active page found
          const firstPage = pages.find(page => {
            const pageId = page.id || "unknown";
            return pageId === "page1";
          });

          if (firstPage) {
            const firstPageId = firstPage.id || "unknown";
            lastTrackedPageIdRef.current = firstPageId;
          }
        }
      }, 1000); // Wait 1 second for AMP to initialize

      // Use polling to detect page changes (forward/back navigation)
      // Only tracks when user actually navigates, not on initial load
      let lastActivePageId = lastTrackedPageIdRef.current;
      checkIntervalRef.current = setInterval(() => {
        // Try multiple selectors to find active page
        const activePage = document.querySelector(
          "amp-story-page.active[id^='page'], amp-story-page.i-amphtml-story-page-active[id^='page'], amp-story-page[active][id^='page']"
        ) || document.querySelector('[id^="page"].active, [id^="page"].i-amphtml-story-page-active');

        if (activePage) {
          const pageId = activePage.id || "unknown";

          // Track whenever the active page changes (forward or back navigation)
          // Only track if it's different from the last tracked page
          if (pageId !== "unknown" && pageId.startsWith('page') && pageId !== lastActivePageId) {
            // Update lastActivePageId immediately to prevent duplicate tracking
            lastActivePageId = pageId;
            lastTrackedPageIdRef.current = pageId;
            const pageNumber = pageId.replace("page", "") || "unknown";
            trackPageView(pageId, pageNumber);
          }
        }
      }, 300); // Check every 300ms for responsive tracking

      setupCompletedRef.current = true;
      return true;
    };

    // Try to setup with retries
    let attempts = 0;
    const maxAttempts = 10;

    const trySetup = () => {
      if (setupCompletedRef.current) return;

      attempts++;
      if (setupPageTracking() || attempts >= maxAttempts) {
        if (attempts >= maxAttempts && !setupCompletedRef.current) {         //do nothing
        }
        return;
      }
      setTimeout(trySetup, 500);
    };

    trySetup();

    // Cleanup - only reset if story URL changes
    return () => {
      // Only cleanup if the story URL is changing
      if (trackedStoryUrlRef.current !== currentStoryUrl) {
        setupCompletedRef.current = false;
        storyViewTrackedRef.current = false;
        trackedStoryUrlRef.current = null;

        if (checkIntervalRef.current) {
          clearInterval(checkIntervalRef.current);
          checkIntervalRef.current = null;
        }
        intersectionObserversRef.current.forEach(({ observer, page }) => {
          try {
            observer.unobserve(page);
            observer.disconnect();
          } catch (e) {
            // Ignore errors during cleanup
          }
        });
        intersectionObserversRef.current = [];
        pageViewCountsRef.current.clear();
        lastApiCallTimeRef.current.clear();
        lastTrackedPageIdRef.current = null;

      }
    };
  }, [storyData?.url, isAmpReady, dispatch]);

  // Helper function to check if media is a video
  const isVideo = (mediaUrl) => {
    if (!mediaUrl) return false;
    const videoExtensions = [".mp4", ".webm", ".ogg", ".mov", ".avi"];
    return videoExtensions.some((ext) => mediaUrl.toLowerCase().includes(ext));
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading story: {error}</div>;
  }

  if (!storyData || !storyData?.images || !isAmpReady) {
    return <div>Loading story content...</div>;
  }

  const images = Array.isArray(storyData.images)
    ? storyData.images
    : storyData.images.split(",");
  const adConfig = {
    "ad-attributes": {
      type: "doubleclick",
      "data-slot": "/22678428348/sandesh_com_webstories",
      // "data-slot": "/30497360/a4a/amp_story_dfp_example", test slot
    },
  };

  return (
    <>
      <Helmet>
        <title>
          {storyData?.seo_title
            ? storyData?.seo_title
            : "Web Stories in Gujarati | ગુજરાતી વેબ સ્ટોરીઝ | Visual Stories in Gujarati"}
        </title>
        <meta
          property="og:title"
          content="Web Stories in Gujarati | ગુજરાતી વેબ સ્ટોરીઝ | Visual Stories in Gujarati"
        />

        {/* <meta name="keywords"  content="" /> */}
        <meta
          name="keywords"
          content={
            storyData?.seo_key
              ? storyData?.seo_key
              : "News, Gujarati News, Web Stories, Visual Stories, Gujarat Web Stories, Entertainment Web Stories, India Web Stories, World Web Stories, Sports Web Stories, Cricket Web Stories, Health Web Stories, Fitness Web Stories, Business Web Stories, Tech Web Stories, lifestyle Web Stories, Food Web Stories, Travel Web Stories, Astrology Web Stories, Bhakti Web Stories, Monsoon Web Stories, Fashion Web Stories, Beauty Web Stories, Celebrity Web Stories, Gujarat Visual Stories, Entertainment Visual Stories, India Visual Stories, World Visual Stories, Sports Visual Stories, Cricket Visual Stories, Health Visual Stories, Fitness Visual Stories, Business Visual Stories, Tech Visual Stories, lifestyle Visual Stories, Food Visual Stories, Travel Visual Stories, Astrology Visual Stories, Bhakti Visual Stories, Monsoon Visual Stories, Fashion Visual Stories, Beauty Visual Stories, Celebrity Visual Stories, ગુજરાતી વેબ સ્ટોરી, ગુજરાતી વેબ વાર્તાઓ, Web Stories in Gujarati, Gujarati Web Stories, News Web Stories"
          }
        />

        {/* <meta name="description" content= /> */}
        <meta
          name="description"
          content={
            storyData?.seo_des
              ? storyData?.seo_des
              : "ગુજરાતી વેબ સ્ટોરીઝ - Find latest trending Gujarati web stories on entertainment, gujarat, india, world, sports, cricket, health, fitness, business, tech, lifestyle, food, travel, astrology, bhakti, monsoon, fashion, beauty, celebrity, viral photos, etc on Sandesh News.."
          }
        />

        {/* add new */}
        <meta
          property="og:title"
          content={
            storyData?.seo_title ||
            storyData?.title ||
            "Web Stories in Gujarati | ગુજરાતી વેબ સ્ટોરીઝ | Visual Stories in Gujarati"
          }
        />
        <meta
          property="og:description"
          content={
            storyData?.seo_des ||
            storyData?.description ||
            "ગુજરાતી વેબ સ્ટોરીઝ - Find latest trending Gujarati web stories on entertainment, gujarat, india, world, sports, cricket, health, fitness, business, tech, lifestyle, food, travel, astrology, bhakti, monsoon, fashion, beauty, celebrity, viral photos, etc on Sandesh News.."
          }
        />
        <meta
          property="og:image"
          content={
            images && images[0]
              ? `${images[0].media}`
              : `/logo.png`
          }
        />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Sandesh News" />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={
            storyData?.seo_title ||
            storyData?.title ||
            "Web Stories in Gujarati | ગુજરાતી વેબ સ્ટોરીઝ | Visual Stories in Gujarati"
          }
        />
        <meta
          name="twitter:description"
          content={
            storyData?.seo_des ||
            storyData?.description ||
            "ગુજરાતી વેબ સ્ટોરીઝ - Find latest trending Gujarati web stories on entertainment, gujarat, india, world, sports, cricket, health, fitness, business, tech, lifestyle, food, travel, astrology, bhakti, monsoon, fashion, beauty, celebrity, viral photos, etc on Sandesh News.."
          }
        />
        <meta
          name="twitter:image"
          content={
            images && images[0]
              ? `${images[0].media}`
              : `/logo.png`
          }
        />

        {/* <meta name="keywords"  content="" /> */}
        <meta
          name="keywords"
          content={
            storyData?.seo_key
              ? storyData?.seo_key
              : "News, Gujarati News, Web Stories, Visual Stories, Gujarat Web Stories, Entertainment Web Stories, India Web Stories, World Web Stories, Sports Web Stories, Cricket Web Stories, Health Web Stories, Fitness Web Stories, Business Web Stories, Tech Web Stories, lifestyle Web Stories, Food Web Stories, Travel Web Stories, Astrology Web Stories, Bhakti Web Stories, Monsoon Web Stories, Fashion Web Stories, Beauty Web Stories, Celebrity Web Stories, Gujarat Visual Stories, Entertainment Visual Stories, India Visual Stories, World Visual Stories, Sports Visual Stories, Cricket Visual Stories, Health Visual Stories, Fitness Visual Stories, Business Visual Stories, Tech Visual Stories, lifestyle Visual Stories, Food Visual Stories, Travel Visual Stories, Astrology Visual Stories, Bhakti Visual Stories, Monsoon Visual Stories, Fashion Visual Stories, Beauty Visual Stories, Celebrity Visual Stories, ગુજરાતી વેબ સ્ટોરી, ગુજરાતી વેબ વાર્તાઓ, Web Stories in Gujarati, Gujarati Web Stories, News Web Stories"
          }
        />

        {/* <meta name="description" content= /> */}
        <meta
          name="description"
          content={
            storyData?.seo_des
              ? storyData?.seo_des
              : "ગુજરાતી વેબ સ્ટોરીઝ - Find latest trending Gujarati web stories on entertainment, gujarat, india, world, sports, cricket, health, fitness, business, tech, lifestyle, food, travel, astrology, bhakti, monsoon, fashion, beauty, celebrity, viral photos, etc on Sandesh News.."
          }
        />

        {/* AMP Scripts */}
        <script async src="https://cdn.ampproject.org/v0.js"></script>
        <script
          async
          custom-element="amp-story"
          src="https://cdn.ampproject.org/v0/amp-story-1.0.js"
        ></script>
        <script
          async=""
          custom-element="amp-ad"
          src="https://cdn.ampproject.org/v0/amp-ad-0.1.js"
        ></script>
        <script
          async
          custom-element="amp-story-auto-ads"
          src="https://cdn.ampproject.org/v0/amp-story-auto-ads-0.1.js"
        ></script>
        <script
          async
          custom-element="amp-video"
          src="https://cdn.ampproject.org/v0/amp-video-0.1.js"
        ></script>
      </Helmet>

      <amp-story
        standalone
        title={storyData.title || "Web Story"}
        publisher="Sandesh News"
        publisher-logo-src={`logo.png`}
        poster-portrait-src={
          images[0] ? generateResizedImageUrl(720, 1280, images[0].media) : ""
        }
      >
        <amp-story-auto-ads>
          <script type="application/json">
            {JSON.stringify(adConfig, null, 2)}
          </script>
        </amp-story-auto-ads>

        {images
          .map((img, index) => {
            const mediaUrl = generateResizedImageUrl(720, 1280, img.media);
            const Video_Media_URL = `${img.media}`;

            const description =
              typeof img.description === "string"
                ? img.description.replace(/<[^>]+>/g, "")
                : "";
            // Get animations for this slide
            const imageAnim = imageAnimations[index % imageAnimations.length];
            const titleAnim = titleAnimations[index % titleAnimations.length];
            const descAnim =
              descriptionAnimations[index % descriptionAnimations.length];

            const isVideoMedia = isVideo(img.media);

            const slides = [
              <amp-story-page
                key={index}
                id={`page${index + 1}`}
                auto-advance-after={isVideoMedia ? "10s" : "5s"}
              >
                <amp-story-grid-layer template="fill">
                  {isVideoMedia ? (
                    <amp-video
                      src={Video_Media_URL}
                      // src={"https://epapercdn.sandesh.com/images/2025/07/28/PRbn06FvtZcvtYfNlkmVzW1ahl8jrzq6gBkMzjS8.mp4"}
                      width="720"
                      height="1280"
                      layout="responsive"
                      autoplay=""
                      loop=""
                      muted=""
                      poster={Video_Media_URL}
                      animate-in={imageAnim.animateIn}
                      animate-in-duration={imageAnim.duration}
                      {...(imageAnim.scale && {
                        "animate-in-scale": imageAnim.scale,
                      })}
                    />
                  ) : (
                    <amp-img
                      src={mediaUrl}
                      width="720"
                      height="1280"
                      layout="responsive"
                      animate-in={imageAnim.animateIn}
                      animate-in-duration={imageAnim.duration}
                      {...(imageAnim.scale && {
                        "animate-in-scale": imageAnim.scale,
                      })}
                    />
                  )}
                </amp-story-grid-layer>

                {/* Gradient overlay */}
                <amp-story-grid-layer template="fill">
                  <div class="story-content"></div>
                </amp-story-grid-layer>

                {/* Next/Prev icon overlays */}
                <amp-story-grid-layer template="fill">
                  {/* Prev icon (left) */}
                  <div
                    onClickCapture={() =>
                      ReactGA.event({
                        category: "webstory",
                        action: "webstory",
                        label: storyData.url,
                      })
                    }
                    style={{
                      position: "absolute",
                      left: 0,
                      top: "50%",
                      transform: "translateY(-50%)",
                      zIndex: 10,
                      pointerEvents: "none",
                      padding: "16px",
                      opacity: 0.7,
                      display: index === 0 ? "none" : "block",
                    }}
                  >
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 24 24"
                      fill="white"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="12"
                        fill="black"
                        opacity="0.4"
                      />
                      <path
                        d="M15 18l-6-6 6-6"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  {/* Next icon (right) */}

                  <div
                    onClickCapture={() =>
                      ReactGA.event({
                        category: "webstory",
                        action: "webstory",
                        label: storyData.url,
                      })
                    }
                    style={{
                      position: "absolute",
                      right: 0,
                      top: "50%",
                      transform: "translateY(-50%)",
                      zIndex: 10,
                      pointerEvents: "none",
                      padding: "16px",
                      opacity: 0.7,
                      display: index === images.length - 1 ? "none" : "block",
                    }}
                  >
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 24 24"
                      fill="white"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="12"
                        fill="black"
                        opacity="0.4"
                      />
                      <path
                        d="M9 6l6 6-6 6"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </amp-story-grid-layer>

                {/* Content layer at the bottom */}
                <amp-story-grid-layer template="vertical" class="bottom">
                  <div
                    class="story-content"
                  >
                    {index === 0 && (
                      <h1
                        class="story-title-web"
                        animate-in={titleAnim.animateIn}
                        animate-in-duration={titleAnim.duration}
                        animate-in-delay={titleAnim.delay || "0s"}
                      >
                        {img.title || ""}
                      </h1>
                    )}
                    {description && (
                      <h2
                        class="story-description"
                        animate-in={descAnim.animateIn}
                        animate-in-duration={descAnim.duration}
                        animate-in-delay={descAnim.delay}
                      >
                        {description}
                      </h2>
                    )}
                    <p
                      class="story-credit"
                      animate-in={descAnim.animateIn}
                      animate-in-duration={descAnim.duration}
                      animate-in-delay={descAnim.delay}
                    >
                      {img?.credit && `credits: ${img.credit}`}
                    </p>
                  </div>
                </amp-story-grid-layer>
              </amp-story-page>,
            ];

            return slides;
          })
          .flat()}

        <amp-story-page id="watch-more-stories">
          {/* Background fill */}
          <amp-story-grid-layer template="fill">
            <div style={{ background: "#fff" }}></div>
          </amp-story-grid-layer>

          {/* Main vertical layout */}
          <amp-story-grid-layer
            template="vertical"
            style={{ alignContent: "center" }}
          >
            <div
              style={{
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                padding: "16px",
                width: "100%",
                boxSizing: "border-box",
              }}
            >
              <h2
                style={{
                  color: "rgb(174 11 13)",
                  fontWeight: "700",
                  margin: "0 0 12px 0",
                  fontFamily: "Gelasio, serif",
                  fontSize: "clamp(18px, 4vw, 24px)", // responsive font size
                }}
              >
                More Web Stories
              </h2>

              {nextStories && nextStories?.watchmoreStories?.length === 0 && (
                <div style={{ fontSize: "14px", color: "#777" }}>
                  More stories coming soon!
                </div>
              )}

              {nextStories &&
                nextStories?.watchmoreStories.map((story, index) => {
                  const cardAnim =
                    watchMoreCardAnimations[
                    index % watchMoreCardAnimations.length
                    ];
                  const imageAnim =
                    watchMoreImageAnimations[
                    index % watchMoreImageAnimations.length
                    ];
                  const titleAnim =
                    watchMoreTitleAnimations[
                    index % watchMoreTitleAnimations.length
                    ];

                  return (
                    <a
                      key={story.id}
                      href={`/webstory/${story.url}`}
                      onClickCapture={() =>
                        ReactGA.event({
                          category: "webstory",
                          action: "webstory",
                          label: story.url,
                        })
                      }
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "5px",
                        textDecoration: "none",
                        color: "#222",
                        borderRadius: "12px",
                        overflow: "hidden",
                        width: "100%",
                        maxWidth: "500px",
                        // background: "#f9f9f9",
                        padding: "10px",
                        boxSizing: "border-box",
                      }}
                      animate-in={cardAnim.animateIn}
                      animate-in-duration={cardAnim.duration}
                      animate-in-delay={cardAnim.delay || "0s"}
                    >
                      <amp-img
                        src={generateResizedImageUrl(80, 80, story?.main_image)}
                        width="80"
                        height="80"
                        layout="fixed"
                        style={{
                          borderRadius: "8px",
                          marginRight: "12px",
                          objectFit: "cover",
                          background: "#eee",
                          minWidth: "55px",
                          minHeight: "55px",
                          maxWidth: "55px",
                          maxHeight: "55px",
                        }}
                        alt={story.title}
                        animate-in={imageAnim.animateIn}
                        animate-in-duration={imageAnim.duration}
                        animate-in-delay={imageAnim.delay || "0s"}
                      />
                      <span
                        style={{
                          fontSize: "clamp(14px, 3vw, 16px)", // responsive
                          fontWeight: "bold",
                          textAlign: "left",
                          lineHeight: "1.3",
                        }}
                        animate-in={titleAnim.animateIn}
                        animate-in-duration={titleAnim.duration}
                        animate-in-delay={titleAnim.delay || "0s"}
                      >
                        {story.title}
                      </span>
                    </a>
                  );
                })}

              <a
                href={`/webstories`}
                style={{
                  color: "rgb(174, 11, 13)",
                  fontSize: "clamp(14px, 3vw, 16px)",
                  textAlign: "center",
                  fontFamily: "Gelasio, serif",
                  fontWeight: "700",
                  marginTop: "10px",
                  textDecoration: "none",
                }}
              >
                View All
              </a>
            </div>
          </amp-story-grid-layer>
        </amp-story-page>

        <amp-story-controls>
          <amp-story-control type="play" />
          <amp-story-control type="pause" />
          <amp-story-control type="share" />
        </amp-story-controls>

        <amp-story-bookend layout="nodisplay">
          <script type="application/json">
            {JSON.stringify({
              shareProviders: ["facebook", "twitter", "whatsapp", "email"],
            })}
          </script>
        </amp-story-bookend>
      </amp-story>
    </>
  );
};

export default WebStoryPage;
